// **********************************************************
// Gallery Slider
// **********************************************************

const gallerySlider = document.querySelectorAll('[data-slider="gallery-slider"]');

const gallerySliderOptions = {
  slidesPerView: 1,
  spaceBetween: 12,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
    renderFraction(currentClass, totalClass) {
      return `<span class="${currentClass}"></span><span> / </span><span class="${totalClass}"></span><span></span>`;
    },
  },
  breakpoints: {
    1023: {
      spaceBetween: 0,
    },
  },
};

gallerySlider.forEach((el) => {
  const parentElem = el.closest('.gallery-slider');
  const paginationElement = parentElem.querySelector('.swiper-pagination');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  gallerySliderOptions.pagination.el = paginationElement;
  gallerySliderOptions.navigation.prevEl = arrowLeft;
  gallerySliderOptions.navigation.nextEl = arrowRight;

  new Swiper(el, gallerySliderOptions);
});
